import React from 'react';
import { renderRoutes, RouteConfig } from 'react-router-config';

function App({ route }: { route?: RouteConfig }) {
  return <div>{route && renderRoutes(route.routes)}</div>;
}

export default App;
